export enum SubscriptionAction {
  SUBSCRIBE = 'subscribe',
  UPGRADE = 'upgrade',
}

export enum SubscriptionStatus {
  NEEDS_SUBSCRIPTION = 'needs_subscription',
  FREE_PREVIEW = 'free_preview',
  FULLY_SUBSCRIBED = 'fully_subscribed',
  NEEDS_UPGRADE = 'needs_upgrade',
  FREE_CONTENT = 'free_content',
  TVOD_SUBSCRIBED = 'tvod_subscribed',
  TVOD_NEEDS_SUBSCRIPTION = 'tvod_needs_subscription',
}

export enum UserSubscriptionStatus {
  NOT_SUBSCRIBED = 'not_subscribed',
  GOLD_SUBSCRIBED = 'gold_subscribed',
  NEEDS_UPGRADE = 'needs_upgrade',
  CANCELLED = 'cancelled',
  ANONYMOUS = 'anonymous',
  // for banner addition status
  REGISTERED = 'registered',
  SUBSCRIBED = 'subscribed',
  CHURNED = 'churned',
}

export enum EntitlementStatus {
  ACTIVE = 'active',
  EXPIRED = 'expired',
  PENDING = 'pending',
  CANCELLED = 'cancelled',
  FINAL_BILL = 'final bill',
  UNKNOWN = 'unknown',
}
